import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import {
  costCenterMsg,
  costCenterToolTipMsg,
  firstNameMsg,
  lastNameMsg,
  nameMsg,
  referenceIdMsg,
  referenceToolTipMsg,
  t,
} from '../../common/i18n/index.js';
import { CostCenter } from '../../common/react-hook-form/fields/CostCenter.js';
import { Email } from '../../common/react-hook-form/fields/Email.js';
import { Name } from '../../common/react-hook-form/fields/Name.js';
import { PhoneNumber } from '../../common/react-hook-form/fields/PhoneNumber.js';
import { Reference } from '../../common/react-hook-form/fields/Reference.js';
import { ContactType } from '../../generated/api/models.js';
import type { CLDescriptionItem } from '../../common/types/componentLibrary';
import type { Contact } from '../../generated/api/models.js';

import './ContactForm.scss';

interface ContactFormProps {
  isEdit: boolean;
  contact?: Contact;
}

export const ContactForm = (props: ContactFormProps) => {
  const { isEdit, contact } = props;

  const nameDescriptionItems: CLDescriptionItem[] = [];
  const contactInfoDescriptionItems: CLDescriptionItem[] = [];
  const costCenterAndReferenceDescriptionItems: CLDescriptionItem[] = [];

  if (contact?.contactType === ContactType.COMMON_FUNCTION) {
    nameDescriptionItems.push({
      title: t.PNS1(nameMsg),
      description: <Name readonly={!isEdit} name="name" label="" />,
    });
  } else {
    const isNameReadonly = !isEdit || contact?.person?.isFirstNameAndLastNameEditable === false;
    nameDescriptionItems.push({
      title: t.AIK7(firstNameMsg),
      description: <Name readonly={isNameReadonly} name="firstName" label="" placeholder={t.AIK7(firstNameMsg)} />,
    });
    nameDescriptionItems.push({
      title: t.Y41S(lastNameMsg),
      description: <Name readonly={isNameReadonly} name="lastName" label="" placeholder={t.Y41S(lastNameMsg)} />,
    });
  }
  contactInfoDescriptionItems.push({
    title: t.V9K9('Mobile phone number (work)'),
    description: (
      <PhoneNumber
        readonly={!isEdit}
        name="phoneNumber"
        label=""
        placeholder={isEdit ? t.V9K9('Mobile phone number (work)') : '-'}
      />
    ),
  });
  contactInfoDescriptionItems.push({
    title: t.JYZO('Email (work)'),
    description: <Email readonly={!isEdit} name="email" label="" placeholder={t.JYZO('Email (work)')} />,
  });
  costCenterAndReferenceDescriptionItems.push({
    title: (
      <span>
        {t.L2OG(costCenterMsg)}
        <CL.Tooltip
          triggerElement={<CL.Icon color="blue-800" type="regular" icon="information" size="s" />}
          i18n_tooltip_contentText={t.UE8R(costCenterToolTipMsg)}
          className={dsClass.MARGIN_LEFT_3}
          placement="top"
        />
      </span>
    ),
    description: (
      <CostCenter readonly={!isEdit} label="" name="costCenter" placeholder={isEdit ? t.L2OG(costCenterMsg) : '-'} />
    ),
  });
  costCenterAndReferenceDescriptionItems.push({
    title: (
      <span>
        {t.CWR5(referenceIdMsg)}
        <CL.Tooltip
          triggerElement={<CL.Icon color="blue-800" type="regular" icon="information" size="s" />}
          i18n_tooltip_contentText={t.HBBD(referenceToolTipMsg)}
          className={dsClass.MARGIN_LEFT_3}
          placement="top"
        />
      </span>
    ),
    description: <Reference readonly={!isEdit} label="" placeholder={isEdit ? t.CWR5(referenceIdMsg) : '-'} />,
  });

  return (
    <div>
      <CL.Description
        className="of-contact-form__description of-contact-form__description-names"
        items={nameDescriptionItems}
        columns={2}
      />
      <CL.Description
        className="of-contact-form__description of-contact-form__description-contact-info"
        items={contactInfoDescriptionItems}
        columns={2}
      />
      <CL.Description
        className="of-contact-form__description of-contact-form__description-costcenter-and-reference"
        items={costCenterAndReferenceDescriptionItems}
        columns={2}
      />
    </div>
  );
};
